import { useChecklistStore } from "@/react/stores/useChecklistStore";
import { Typography } from "@circle-react-uikit/Typography";
import type { Step } from "../../types";
import { StepIcon } from "./StepIcon";
import { StepWrapper } from "./StepWrapper";

interface CompletedStepProps {
  isVisible: boolean;
  step: Step;
}

export const CompletedStep = ({ step, isVisible }: CompletedStepProps) => {
  const { setFocusedStepKey } = useChecklistStore();

  const handleFocus = () => setFocusedStepKey(step.key);

  return (
    <StepWrapper isVisible={isVisible}>
      <button
        type="button"
        className="flex w-full items-center justify-start gap-x-4 px-4 py-5 text-left"
        onClick={handleFocus}
      >
        <StepIcon status="complete" />
        <Typography.LabelSm
          weight="medium"
          size="text-sm"
          color="text-default"
          textTransform="line-through"
        >
          {step.title}
        </Typography.LabelSm>
      </button>
    </StepWrapper>
  );
};
